import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface ItemFormula {
    itemFormulas: ItemFormulaListItem[];
    loading: boolean;
    errors: any;
}

interface ItemFormulaListItem {
    id: number;
    name: string;
    installFormula: number;
    pickupFormula: number;
    formula: string;
    twoPplExampleFormatted: string;
    twoPplExampleTimeFormatted: string;
    threePplExampleFormatted: string;
    threePplExampleTimeFormatted: string;
    isDirty: boolean;
}

export class ItemFormulaData extends React.Component<RouteComponentProps<{}>, ItemFormula> {
    constructor(props: any) {
        super(props);

        this.state = {
            itemFormulas: [],
            loading: true,
            errors: {}
        };

    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();
        axios.get('api/User/CheckUserPermission?Permission=CreateEditAdminLists&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                this.getAdminFormulas();
            } else if (res.data == false) {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    getAdminFormulas = async () => {
        const token = await authService.getAccessToken();

        axios.get('api/Admin/GetItemFormulas', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ itemFormulas: res.data.itemFormulas, loading: false });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleInstallCellChange = (e: any, itemIndex: number) => {
        e.preventDefault();

        var itemList = this.state.itemFormulas;
        var item = itemList[itemIndex];

        item.installFormula = e.target.value * 1;
        item.isDirty = true;

        this.setState({ itemFormulas: itemList, errors: {} });
    }

    handlePickupCellChange = (e: any, itemIndex: number) => {
        e.preventDefault();

        var itemList = this.state.itemFormulas;
        var item = itemList[itemIndex];

        item.pickupFormula = e.target.value * 1;
        item.isDirty = true;

        this.setState({ itemFormulas: itemList, errors: {} });
    }

    validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        var itemList = this.state.itemFormulas.filter(i => i.isDirty);

        var rowNumber = 0;
        var errorString = "Please enter the following values: ";
        var error = false;

        for (var i = 0; i < itemList.length; i++) {
            rowNumber += 1;
            var newErrorString = "";

            if (itemList[i].installFormula < 0.01) {
                newErrorString += "Install Formula > 0, ";
                error = true;
            }

            if (itemList[i].pickupFormula < 0.01) {
                newErrorString += "Pickup Formula > 0, ";
                error = true;
            }

            if (newErrorString != "") {
                errorString += "\n"
                errorString += "Row " + rowNumber + ": " + newErrorString;
                errorString = errorString.substring(0, errorString.length - 2);
            }

        }
        if (error) {
            formIsValid = false;
            errorList["pricelistitems"] = errorString;
        }
        this.setState({ errors: errorList });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            var changed = this.state.itemFormulas.filter(p => p.isDirty);

            if (changed.length === 0) {
                toast.info("No items have changed.");
            } else {
                this.saveItemFormulas(changed);
            }
        } else {
            toast.error("Please fix validation errors before Saving")
        }
    }

    saveItemFormulas = async (changed: ItemFormulaListItem[]) => {
        const token = await authService.getAccessToken();

        var saveItemFormulas = {
            itemFormulas: changed
        };

        axios.post('api/Admin/SaveItemFormulas', saveItemFormulas, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                toast.success("Price List Saved Successfully");
                this.getAdminFormulas();
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return <div>
            <h1>Item Formulas</h1>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let itemFormulas = this.state.itemFormulas;

        return (
            <div>
                <div>Void Example: Installing 1 Void</div>
                <div>Other Example: Installing 40 Quantity</div>

                <div>
                    <div className="overflowAuto">
                        <table className="table tableColours">
                            <thead>
                                <tr>
                                    <th className="hidden">Id</th>
                                    <th>Name</th>
                                    <th>Install Formula</th>
                                    <th>Dismantle Formula</th>
                                    <th>Total Minutes Formula</th>
                                    <th>2 Person Eg (mins)</th>
                                    <th>2 Person Eg (hh:mm)</th>
                                    <th>3 Person Eg (mins)</th>
                                    <th>3 Person Eg (hh:mm)</th>
                                </tr>
                            </thead>
                            {itemFormulas.map((item, index) =>
                                <tbody key={item.id}>
                                    <tr>
                                        <td className="hidden">{item.id}</td>
                                        <td className="table__text--align">{item.name}</td>
                                        <td className="table__text--align">
                                            <input type='number' min="0" step="0.01" className='form-control textalignright' id="installFormula" name="installFormula" value={item.installFormula} onChange={(e) => this.handleInstallCellChange(e, index)} />
                                        </td>
                                        <td className="table__text--align">
                                            <input type='number' min="0" step="0.01" className='form-control textalignright' id="pickupFormula" name="pickupFormula" value={item.pickupFormula} onChange={(e) => this.handlePickupCellChange(e, index)} />
                                        </td>
                                        <td className="table__text--align">{item.formula}</td>
                                        <td className="table__text--align">{item.twoPplExampleFormatted}</td>
                                        <td className="table__text--align">{item.twoPplExampleTimeFormatted}</td>
                                        <td className="table__text--align">{item.threePplExampleFormatted}</td>
                                        <td className="table__text--align">{item.threePplExampleTimeFormatted}</td>
                                    </tr>
                                </tbody>
                            )}
                        </table>
                    </div>
                    <button className="defaultbutton defaultbutton__large marginBottom10" type="button" onClick={this.save} disabled={this.state.loading}>Save</button>
                </div>

            </div>
        );
    }
}